/* global jQuery, require */
import { Modal } from 'bootstrap';


( ( $ ) => {

        const $page = document.querySelector('#page'); // select page

		$( '[href^="#modal-"]' ).each( ( _index, element ) => {
			const href = $( element ).attr( 'href' );
            
            var lastFocus;

			if ( ! $( `[data-idx="${ href }"]`, document ).length ) {
				return;
			}
            

			$( element ).on( 'click', ( event ) => {
				event.preventDefault();
                
				const modal = $( `[data-idx="${ href }"]` );

                // fix for vimeo videos. When resolution is low, it tends to embed the iframe in low size.
				if ( modal.find( '.is-provider-vimeo' ).length > 0 ) {
					if ( modal.find( 'iframe' ).attr( 'width' ) < 1000 ) {
						modal.find( 'iframe' ).attr( 'width', '1100' );
					}
					if ( modal.find( 'iframe' ).attr( 'height' ) < 600 ) {
						modal.find( 'iframe' ).attr( 'height', '619' );
					}
				}

                modal.on('show.bs.modal', function(e) {
                    lastFocus = $(':focus-visible');
        
                  });

                modal.on('shown.bs.modal', function () {
                    $page.inert = true;
                    modal.find('iframe').attr('src', modal.find('iframe').attr('src'));
					$("#hu").css("z-index", "50");
                });

                modal.on( 'hidden.bs.modal', ( event ) => {
                   $page.inert = false;
                    var src = modal.find( 'iframe' ).attr('src');
                    modal.find('iframe').attr('src', "");
                    modal.find('iframe').attr('src', src);

                    if(lastFocus) {
                        lastFocus.focus();
                      }
                    
                    /*modal.find('iframe').attr('src', modal.find('iframe').attr('src'));*/

                
                });

				new Modal( `[data-idx="${ href }"]`, { backdrop: 'static', keyboard: false } ).toggle();
                
                

			} );
            
            //OPEN MODAL FROM URL
            
            $( window ).on( 'load', ( event ) => {
            
            if (window.location.hash == href) {
                 event.preventDefault();
                const modal = $( `[data-idx="${ href }"]` );


                modal.on('shown.bs.modal', function () {
                    $page.inert = true;
                    modal.find('iframe').attr('src', modal.find('iframe').attr('src'));
                });
                
                modal.on( 'hidden.bs.modal', ( event ) => {
                    $page.inert = false;
                    var src = modal.find( 'iframe' ).attr('src');
                    modal.find('iframe').attr('src', "");
                    modal.find('iframe').attr('src', src);

                });
                
                    
                
                 new Modal( `[data-idx="${ href }"]`, { backdrop: 'static', keyboard: false } ).toggle();
             }
                
                else {
                    return;
                }
                
                } );
            

            
            
            
		} );
    
    //FIX TO KEEP BACKGROUND FROM SCROLLING BEHIND MODAL WINDOWS - NEED TO MOVE MODALS SO THEY AREN'T NESTED INSIDE BODY

    const modalFocus = () => {
        const $modalComponent = document.querySelectorAll('div[id^="modal-block"]'); // select the modal by it's id 

        if ( $modalComponent.length > 0)   {  
            
            $modalComponent.forEach(function( element ) {
  
                document.body.appendChild(element);
            });
        }
    };
  
      modalFocus();
  
      
    

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction(
			'render_block_preview/type=modal',
			initializeBlock
		);
	}
} )( jQuery );


